import type {
  BoardStickersTabBoardState,
  BoardStickersTabSliceState,
} from './boardStickersTab.types'

export const EMPTY_BOARD_STICKERS_TAB_BOARD_STATE: BoardStickersTabBoardState = {
  catalog: [],
  boardStickers: [],
  loading: false,
  error: null,
  visibilityLoadingIds: [],
  requiredLoadingIds: [],
  reorderingStickerId: null,
}

export const createEmptyBoardStickersTabBoardState =
  (): BoardStickersTabBoardState => ({
    catalog: [],
    boardStickers: [],
    loading: false,
    error: null,
    visibilityLoadingIds: [],
    requiredLoadingIds: [],
    reorderingStickerId: null,
  })

export const createInitialBoardStickersTabState =
  (): BoardStickersTabSliceState => ({
    byBoardId: {},
  })
